import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, errText } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { BrandHeader, Logo } from "@/components/Brand";
import { Btn } from "@/components/Btn";

export default function MagicLink() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const { signIn, setUser } = useAuth();
  const [err, setErr] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    api
      .post("/auth/magic-link/verify", { token: sp.get("token") || "" }, { timeout: 20000 })
      .then(({ data }) => {
        signIn(data);
        navigate("/", { replace: true });
      })
      .catch((e) => {
        setErr(errText(e));
        setUser(false);
      });
  }, [sp, signIn, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col px-6 py-8 max-w-xl mx-auto">
      <BrandHeader />
      <div className="my-auto text-center flex flex-col items-center gap-4" data-testid="magic-page">
        {err ? (
          <>
            <h1 className="text-3xl font-bold text-t-on">Link not working</h1>
            <p className="text-t-on2" data-testid="magic-error">{err}</p>
            <Btn label="Back to sign in" onClick={() => navigate("/auth", { replace: true })} testId="magic-back" />
          </>
        ) : (
          <>
            <div className="animate-pulse"><Logo size={64} /></div>
            <p className="text-t-muted">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
